import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
import Select from 'react-select';
import Workbook from 'react-excel-workbook'
import CsvParse from '@vtex/react-csv-parse';
import moment from 'moment';
import ReactGA from 'react-ga';
const { proxy } = require('../../../ip_api.config')

class Film_MasterStandard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewItem: '',
            onPage: 'Preview',
            arr_temp_edit: [],
            arr_save: [],
            Type: '',
            template: [{
                Type: '',
                DefaultOrderType: '',
                EcoResTrackingDimensionGroup_Name: '',
                ItemGroupId: '',
                CostGroupId: '',
                BatchNumGroupId: '',
                SerialNumGroupId: '',
                InventTableModuleInvent_UnitId: '',
                InventTableModulePurch_UnitId: '',
                InventTableModulePurch_OverDeliveryPct: '',
                InventTableModulePurch_UnderDeliveryPct: '',
                InventTableModuleSales_UnitId: '',
                ECL_NumberSequenceGroupProd: '',
                BOMUnitId: '',
                DefaultDimension: ''
            }],
            checkAll: true,
            checked: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/MasterStandard');

        if (localStorage.getItem("ID_User") !== null) {
            this.getOptionStandard()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getOptionStandard = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_type = []
        let dataWhere = {
            type: '',
        }
        let url = proxy.server + '/flim/getMaster_Standard'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {

                    arroption_type.push(
                        { value: val.Type, label: val.Type }
                    )
                }, this)

                let newArray_type = await this.setUniqueArray(arroption_type)
                this.setState({ option_type: newArray_type }, () => {
                    this.getMasterStandard()
                })
            })
    }

    setUniqueArray = async (arroption) => new Promise((resolve, reject) => {
        let newArray = [];
        let uniqueObject = {};

        for (let i in arroption) {
            let objTitle = arroption[i]['value'];
            uniqueObject[objTitle] = arroption[i];
        }

        for (let i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        resolve(newArray)
    })

    getMasterStandard = () => {
        this.setState({ isLoading: true, onPage: 'Preview', checkAll: true })
        let arr = []
        let dataWhere = {
            type: this.state.Type,
        }
        let url = proxy.server + '/flim/getMaster_Standard'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.Type}</td>
                            <td>{val.DefaultOrderType}</td>
                            <td>{val.EcoResTrackingDimensionGroup_Name}</td>
                            <td>{val.ItemGroupId}</td>
                            <td>{val.CostGroupId}</td>
                            <td>{val.BatchNumGroupId}</td>
                            <td>{val.SerialNumGroupId}</td>
                            <td>{val.InventTableModuleInvent_UnitId}</td>
                            <td>{val.InventTableModulePurch_UnitId}</td>
                            <td>{val.InventTableModulePurch_OverDeliveryPct}</td>
                            <td>{val.InventTableModulePurch_UnderDeliveryPct}</td>
                            <td>{val.InventTableModuleSales_UnitId}</td>
                            <td>{val.ECL_NumberSequenceGroupProd}</td>
                            <td>{val.BOMUnitId}</td>
                            <td>{val.DefaultDimension}</td>
                        </tr>
                    )
                }, this)
                this.setState({
                    previewItem: arr, isLoading: false, result: responseJson.result,
                    arrDataExcel: responseJson.result, filename: 'MasterStandrad' + moment().format('YYYYMMDD')
                })
            })
    }

    getItem_Edit = () => {
        this.setState({ isLoading: true, onPage: 'Edit' })
        let arr = []
        let dataWhere = {
            type: this.state.Type,
        }
        let url = proxy.server + '/flim/getMaster_Standard'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td style={{ justifyContent: 'center' }}>
                                {/* <bs4.Col>
                                    <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                        onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                </bs4.Col> */}
                                <bs4.Col>
                                    {
                                        this.state.checked === ''
                                            ? <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                                onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                                            : <bs4.Input type="checkbox" style={{ width: 23, height: 23 }} checked />
                                    }
                                </bs4.Col>
                            </td>
                            <td>{val.Type}</td>
                            <td>{val.DefaultOrderType}</td>
                            <td>{val.EcoResTrackingDimensionGroup_Name}</td>
                            <td>{val.ItemGroupId}</td>
                            <td>{val.CostGroupId}</td>
                            <td>{val.BatchNumGroupId}</td>
                            <td>{val.SerialNumGroupId}</td>
                            <td>{val.InventTableModuleInvent_UnitId}</td>
                            <td>{val.InventTableModulePurch_UnitId}</td>
                            <td>{val.InventTableModulePurch_OverDeliveryPct}</td>
                            <td>{val.InventTableModulePurch_UnderDeliveryPct}</td>
                            <td>{val.InventTableModuleSales_UnitId}</td>
                            <td>{val.ECL_NumberSequenceGroupProd}</td>
                            <td>{val.BOMUnitId}</td>
                            <td>{val.DefaultDimension}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewItem: arr, isLoading: false })
            })
    }

    checkItem = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    checkAll = (check) => {
        let arr = []
        let data = ''
        // let data = {}

        if (check) {
            data = 'checked'
            this.state.result.map(function (val, i) {
                arr.push({
                    id: val.id
                })
            })
        }

        this.setState({
            arr_temp_edit: arr,
            checkAll: !this.state.checkAll,
            checked: data
        }, () => {
            console.log('arr_temp_edit', this.state.arr_temp_edit)
            this.getItem_Edit()
        })
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/Flim/editMasterStandard',
            state: { id_edit: this.state.arr_temp_edit }
        })
    }

    Delete_item = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/delete_masterStandard'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.setState({ arr_save: [], show_item: '' }, () => this.getMasterStandard())
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถลบข้อมูลได้ กรุณาตรวจสอบอีกครั้ง')
                        })
                    }
                })
        }
    }

    addData = () => {
        const { arr_save } = this.state
        let arr = []
        let temp
        // arr_check.map(function (val, i) {
        let data = {
            Type: '',
            DefaultOrderType: '',
            EcoResTrackingDimensionGroup_Name: '',
            ItemGroupId: '',
            CostGroupId: '',
            BatchNumGroupId: '',
            SerialNumGroupId: '',
            InventTableModuleInvent_UnitId: '',
            InventTableModulePurch_UnitId: '',
            InventTableModulePurch_OverDeliveryPct: '',
            InventTableModulePurch_UnderDeliveryPct: '',
            InventTableModuleSales_UnitId: '',
            ECL_NumberSequenceGroupProd: '',
            BOMUnitId: '',
            DefaultDimension: ''
        }

        arr.push(data)

        temp = arr_save.concat(arr)

        this.setState({
            arr_save: temp
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.showItem()
        })
    }

    showItem = () => {
        let arr = []
        this.state.arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="Type" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="DefaultOrderType" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="EcoResTrackingDimensionGroup_Name" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="ItemGroupId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="CostGroupId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="BatchNumGroupId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="SerialNumGroupId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModuleInvent_UnitId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModulePurch_UnitId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModulePurch_OverDeliveryPct" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModulePurch_UnderDeliveryPct" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModuleSales_UnitId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="ECL_NumberSequenceGroupProd" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="BOMUnitId" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="DefaultDimension" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)

        this.setState({ show_item: arr }, () => {
            console.log('arr_save', this.state.arr_save)
        })
    }

    onDelete = (index) => {
        this.state.arr_save.splice(index, 1)
        this.setState({
            arr_save: this.state.arr_save,
        }, () => {
            this.showItem()
        })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'Type') {
            this.state.arr_save[index].Type = value
        } else if (name === 'DefaultOrderType') {
            this.state.arr_save[index].DefaultOrderType = value
        } else if (name === 'EcoResTrackingDimensionGroup_Name') {
            this.state.arr_save[index].EcoResTrackingDimensionGroup_Name = value
        } else if (name === 'ItemGroupId') {
            this.state.arr_save[index].ItemGroupId = value
        } else if (name === 'CostGroupId') {
            this.state.arr_save[index].CostGroupId = value
        } else if (name === 'BatchNumGroupId') {
            this.state.arr_save[index].BatchNumGroupId = value
        } else if (name === 'SerialNumGroupId') {
            this.state.arr_save[index].SerialNumGroupId = value
        } else if (name === 'InventTableModuleInvent_UnitId') {
            this.state.arr_save[index].InventTableModuleInvent_UnitId = value
        } else if (name === 'InventTableModulePurch_UnitId') {
            this.state.arr_save[index].InventTableModulePurch_UnitId = value
        } else if (name === 'InventTableModulePurch_OverDeliveryPct') {
            this.state.arr_save[index].InventTableModulePurch_OverDeliveryPct = value
        } else if (name === 'InventTableModulePurch_UnderDeliveryPct') {
            this.state.arr_save[index].InventTableModulePurch_UnderDeliveryPct = value
        } else if (name === 'InventTableModuleSales_UnitId') {
            this.state.arr_save[index].InventTableModuleSales_UnitId = value
        } else if (name === 'ECL_NumberSequenceGroupProd') {
            this.state.arr_save[index].ECL_NumberSequenceGroupProd = value
        } else if (name === 'BOMUnitId') {
            this.state.arr_save[index].BOMUnitId = value
        } else if (name === 'DefaultDimension') {
            this.state.arr_save[index].DefaultDimension = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.showItem()
        })
    }

    saveItem = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            let url = proxy.server + '/flim/insert_masterStandard'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(this.state.arr_save)
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        alert('บันทึกสำเร็จ')
                        this.setState({ arr_save: [], show_item: '' }, () => this.getMasterStandard())
                    } else {
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    allData_Preveiw = () => {
        window.location.reload()
    }

    showUpload = () => {
        const keys = [
            'Type', 'DefaultOrderType', 'EcoResTrackingDimensionGroup_Name', 'ItemGroupId', 'CostGroupId', 'BatchNumGroupId',
            'SerialNumGroupId', 'InventTableModuleInvent_UnitId', 'InventTableModulePurch_UnitId', 'InventTableModulePurch_OverDeliveryPct',
            'InventTableModulePurch_UnderDeliveryPct', 'InventTableModuleSales_UnitId', 'ECL_NumberSequenceGroupProd', 'BOMUnitId', 'DefaultDimension'
        ]
        if (this.state.upload_open === true) {
            var Upload = <bs4.FormGroup row style={{ marginLeft: '25px', marginBottom: '25px', marginRight: 40 }}>
                <bs4.Label style={{ color: 'red', marginRight: "20px" }}> **รองรับเฉพาะไฟล์ .csv เท่านั้น</bs4.Label>
                <CsvParse
                    keys={keys}
                    onDataUploaded={(data) => { this.setState({ arr_save: data }) }}
                    onError={this.handleError}
                    render={onChange => <input type="file" onChange={onChange} />
                    }
                />
            </bs4.FormGroup>
        }

        this.setState({ showUpload: Upload, upload_open: !this.state.upload_open })
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Type</bs4.Label>
                    <bs4.Col sm='6'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ Type: e.value })}
                            options={this.state.option_type}
                            placeholder={'ค้นหา Type'}
                        />
                    </bs4.Col>
                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getMasterStandard()}>SEARCH</bs4.Button>
                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.allData_Preveiw()}>ดูข้อมูลทั้งหมด</bs4.Button>
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 23, fontWeight: 500, marginRight: 10, marginBottom: 20 }}>ข้อมูล Standard</bs4.Label>
                    {
                        this.state.onPage === 'Preview'
                            ? <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.addData()}>ADD DATA</bs4.Button>
                                <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem_Edit()}>EDIT</bs4.Button>
                            </div>
                            : <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.getMasterStandard()}>CANCEL</bs4.Button>
                            </div>

                    }
                    <div style={{ justifyContent: 'flex-end' }}>
                        <Workbook filename={this.state.filename + '.xlsx'} element={<bs4.Button outline color="success" style={{ fontWeight: 500, marginRight: 20 }}>EXPORT EXCEL</bs4.Button>} >
                            <Workbook.Sheet data={this.state.arrDataExcel} name="sheet1">
                                <Workbook.Column label="Type" value="Type" />
                                <Workbook.Column label="DefaultOrderType" value="DefaultOrderType" />
                                <Workbook.Column label="EcoResTrackingDimensionGroup_Name" value="EcoResTrackingDimensionGroup_Name" />
                                <Workbook.Column label="ItemGroupId" value="ItemGroupId" />
                                <Workbook.Column label="CostGroupId" value="CostGroupId" />
                                <Workbook.Column label="BatchNumGroupId" value="BatchNumGroupId" />
                                <Workbook.Column label="SerialNumGroupId" value="SerialNumGroupId" />
                                <Workbook.Column label="InventTableModuleInvent_UnitId" value="InventTableModuleInvent_UnitId" />
                                <Workbook.Column label="InventTableModulePurch_UnitId" value="InventTableModulePurch_UnitId" />
                                <Workbook.Column label="InventTableModulePurch_OverDeliveryPct" value="InventTableModulePurch_OverDeliveryPct" />
                                <Workbook.Column label="InventTableModulePurch_UnderDeliveryPct" value="InventTableModulePurch_UnderDeliveryPct" />
                                <Workbook.Column label="InventTableModuleSales_UnitId" value="InventTableModuleSales_UnitId" />
                                <Workbook.Column label="ECL_NumberSequenceGroupProd" value="ECL_NumberSequenceGroupProd" />
                                <Workbook.Column label="BOMUnitId" value="BOMUnitId" />
                                <Workbook.Column label="DefaultDimension" value="DefaultDimension" />
                            </Workbook.Sheet>
                        </Workbook>
                        <bs4.Button color="warning" outline style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.showUpload()}>IMPORT</bs4.Button>
                        <Workbook filename={'templateMasterStandard.xlsx'} element={<bs4.Button color="warning" style={{ fontWeight: 500, marginRight: 20 }}>DOWNLOAD TEMPLATE</bs4.Button>} >
                            <Workbook.Sheet data={this.state.template} name="sheet1">
                                <Workbook.Column label="Type" value="Type" />
                                <Workbook.Column label="DefaultOrderType" value="DefaultOrderType" />
                                <Workbook.Column label="EcoResTrackingDimensionGroup_Name" value="EcoResTrackingDimensionGroup_Name" />
                                <Workbook.Column label="ItemGroupId" value="ItemGroupId" />
                                <Workbook.Column label="CostGroupId" value="CostGroupId" />
                                <Workbook.Column label="BatchNumGroupId" value="BatchNumGroupId" />
                                <Workbook.Column label="SerialNumGroupId" value="SerialNumGroupId" />
                                <Workbook.Column label="InventTableModuleInvent_UnitId" value="InventTableModuleInvent_UnitId" />
                                <Workbook.Column label="InventTableModulePurch_UnitId" value="InventTableModulePurch_UnitId" />
                                <Workbook.Column label="InventTableModulePurch_OverDeliveryPct" value="InventTableModulePurch_OverDeliveryPct" />
                                <Workbook.Column label="InventTableModulePurch_UnderDeliveryPct" value="InventTableModulePurch_UnderDeliveryPct" />
                                <Workbook.Column label="InventTableModuleSales_UnitId" value="InventTableModuleSales_UnitId" />
                                <Workbook.Column label="ECL_NumberSequenceGroupProd" value="ECL_NumberSequenceGroupProd" />
                                <Workbook.Column label="BOMUnitId" value="BOMUnitId" />
                                <Workbook.Column label="DefaultDimension" value="DefaultDimension" />
                            </Workbook.Sheet>
                        </Workbook>
                    </div>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>

                <bs4.FormGroup row style={{ marginLeft: 10 }}>
                    {this.state.showUpload}
                    {
                        this.state.arr_save.length > 0
                            ? <div>
                                <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>
                                <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ arr_save: [], showUpload: '' }, () => this.showItem())}>CANCEL</bs4.Button>
                            </div>
                            : ''
                    }
                </bs4.FormGroup>
                <bs4.Table bordered hover>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th style={{ backgroundColor: '#fff' }}>
                                {this.state.onPage === 'Edit' && <bs4.Button color="danger" size='sm' onClick={() => this.checkAll(this.state.checkAll)}>ALL</bs4.Button>}
                            </th>
                            <th>Type</th>
                            <th>DefaultOrderType</th>
                            <th>EcoResTracking<br />Dimension<br />Group_Name</th>
                            <th>ItemGroupId</th>
                            <th>CostGroupId</th>
                            <th>BatchNumGroupId</th>
                            <th>SerialNumGroupId</th>
                            <th>InventTable<br />ModuleInvent<br />_UnitId</th>
                            <th>InventTable<br />ModulePurch<br />_UnitId</th>
                            <th>InventTable<br />ModulePurch_<br />OverDeliveryPct</th>
                            <th>InventTable<br />ModulePurch_<br />UnderDeliveryPct</th>
                            <th>InventTable<br />ModuleSales_<br />UnitId</th>
                            <th>ECL_Number<br />Sequence<br />GroupProd</th>
                            <th>BOMUnitId</th>
                            <th>Default<br />Dimension</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.show_item}
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Film_MasterStandard